import { createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08a713c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "multiple-line-turn-path-map-container" }
const _hoisted_2 = { class: "map-content-area" }
const _hoisted_3 = {
  ref: "mapContainer",
  id: "map"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavigationBar"], {
      title: $setup.title,
      shouldHideBackButton: true,
      onOnClickClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('onClickClose')))
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, null, 512 /* NEED_PATCH */),
      _createVNode($setup["LineTurnPathLegend"], {
        class: "legend-position",
        lineInfos: $props.lineInfos,
        linePathColorInfos: $props.linePathColorInfos
      }, null, 8 /* PROPS */, ["lineInfos", "linePathColorInfos"]),
      _createVNode($setup["MapZoomLevelSetter"], {
        class: "zoom-level-setter",
        zoomLevel: $setup.zoomLevel,
        maxZoomLevel: $setup.MAX_ZOOM_LEVEL,
        minZoomLevel: $setup.MIN_ZOOM_LEVEL,
        onZoomIn: _cache[1] || (_cache[1] = ($event: any) => ($setup.increaseZoomLevel($setup.map))),
        onZoomOut: _cache[2] || (_cache[2] = ($event: any) => ($setup.decreaseZoomLevel($setup.map)))
      }, null, 8 /* PROPS */, ["zoomLevel"]),
      _createCommentVNode(" <button\n        ref=\"refreshButton\"\n        class=\"refresh-icon-wrapper\"\n        type=\"button\"\n        @click=\"emitOnClickRefreshBtn\"\n      >\n        <InlineSvg :src=\"require('@/assets/icons/rotate.svg')\" alt=\"새로고침\" />\n      </button> ")
    ])
  ]))
}